import Axios from 'axios';
import Env from '@/plugins/protokol/lib/Env'

const http = Axios.create({
  baseURL: Env.get("HOST") + "/ratchet",
  timeout: 15000
});


http.defaults.withCredentials = true
http.interceptors.request.use(function(config) {
  config.headers["X-Project-Uuid"] = localStorage.getItem("current_project_uuid")
  config.headers["X-Workspace-Uuid"] = localStorage.getItem("current_workspace_uuid")
  config.headers["X-Project-Env"] = localStorage.getItem("current_env")
  
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

export default http